module.exports = __webpack_public_path__ + "img/amdox-QR.56494e49.png";